<template>
    <div style="position:relative;">
        <template v-if="chat.type == JOIN_CHAT_TYPE.GROUP">
            <div class="header" ref="member_talk" style="padding-bottom: 16px; position: relative;" :style="{ paddingTop: $GlobalStore.statusBarHeight() + 'px' }">
                <div style="margin-top: 10px; margin-bottom: 20px; display: flex; position: relative; justify-content: space-between; align-items: center;">
                    <div @click="() => { $GlobalStore.closeLastModal() }" style="padding-left: 20px; display: flex; gap: 4px; align-items: center;">
                        <img style="width: 10px;" :src="require('@/assets/img/white_arrow.png')" alt="">
                        <div style="color: #fff; font-size: 14px; font-weight: 500;">뒤로가기</div>
                    </div>
                    <div v-if="!isCoach" style="position: absolute; color: #fff; line-height: 24px; font-weight: 700; left: 50%; transform: translateX(-50%);">멤버톡</div>
                    <div v-else style="position: absolute; color: #fff; line-height: 24px; font-weight: 700; left: 50%; transform: translateX(-50%);">회원 관리 채팅</div>
                    <div @click="showMemberTalkSetting" style="display: flex; align-items: center; gap: 4px; padding-right: 12px;">
                        <div style="width: 8px; height: 8px; border-radius: 50%; background-color: #fff;"></div>
                        <div style="width: 8px; height: 8px; border-radius: 50%; background-color: #fff;"></div>
                        <div style="width: 8px; height: 8px; border-radius: 50%; background-color: #fff;"></div>
                    </div>
                </div>
                <div v-if="joinDetail.join_tag" style="text-align: center; ">
                    <div style="font-size: 20px;font-weight: 700;line-height: 24px; margin-bottom: 4px;color:white;">{{ title ? title : '&nbsp;' }}</div>
                    <div style="display: flex; align-items: center; gap: 4px; justify-content: center;">
                        <div style="font-size: 14px; font-weight: 500; line-height: 16px; color: white;">{{ joinDetail.join_tag[0] ? joinDetail.join_tag[0] : '&nbsp;' }}</div>
                        <div style="width: 3px; height: 3px; background-color: #606060; border-radius: 50%;"></div>
                        <div style="font-size: 14px; font-weight: 500; line-height: 16px; color: white">{{ joinDetail.cur_cnt }}명 참여중</div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="chat.type == JOIN_CHAT_TYPE.OPEN">
            <div class="header" ref="member_talk" style="position: relative;" :style="{ paddingTop: $GlobalStore.statusBarHeight() + 'px' }">
                <div style="margin-top: 10px; margin-bottom: 20px; display: flex; position: relative; justify-content: space-between; align-items: center;">
                    <div @click="() => { $GlobalStore.closeLastModal() }" style="padding-left: 20px; display: flex; gap: 4px; align-items: center;">
                        <img style="width: 10px;" :src="require('@/assets/img/white_arrow.png')" alt="">
                        <div style="color: #fff; font-size: 14px; font-weight: 500;">뒤로가기</div>
                    </div>
                    <div style="position: absolute; color: #fff; line-height: 24px; font-weight: 700; left: 50%; transform: translateX(-50%);">멤버톡</div>
                    <div @click="showMemberTalkSetting" style="display: flex; align-items: center; gap: 4px; padding-right: 12px;">
                        <div style="width: 8px; height: 8px; border-radius: 50%; background-color: #fff;"></div>
                        <div style="width: 8px; height: 8px; border-radius: 50%; background-color: #fff;"></div>
                        <div style="width: 8px; height: 8px; border-radius: 50%; background-color: #fff;"></div>
                    </div>
                </div>
                <div style="text-align: center;  padding-bottom: 16px">
                    <div style="font-size: 20px;font-weight: 700;line-height: 24px; margin-bottom: 4px; color:white;">{{ openMemberTalkInfo.region }} 오픈 멤버톡</div>
                    <div style="display: flex; align-items: center; gap: 4px; justify-content: center;">
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px;color:white;">{{ openMemberTalkInfo.region }} 모든 지역</div>
                        <div style="width: 3px; height: 3px; background-color: #606060; border-radius: 50%;"></div>
                        <div style="font-size: 12px; font-weight: 500; line-height: 16px; color:white;">{{ members.length }}명 참여중</div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="chat.type == JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT">
            <div style="display: flex; align-items: center; margin-top: 20px; position: relative; justify-content: space-between; padding-bottom: 11px;">
                <div style="flex:1; display:flex; align-items: center; " @click="() => { $GlobalStore.closeLastModal() }">
                    <img :src="require('@/assets/images/mypage/ico-move.png')" style="width: 10px; transform: rotate(180deg);margin-left: 20px;">
                    <span style="font-size:14px; font-weight:500; margin-left:5px; color:#210F03;">뒤로가기</span>
                </div>
                <div style="display:flex;flex-direction: column;justify-content: center; align-items: center; position: absolute; left: 50%; transform: translateX(-50%); font-weight:bold; font-size:16px;">
                    <div style="font-size:16px; color:#210F03; max-width:150px; overflow:hidden;text-overflow: ellipsis; white-space: nowrap;">사커하우 고객지원</div>
                </div>
                <div style="flex:1; display:flex; flex-direction: row-reverse; gap: 4px; position: relative; padding-right: 12px;"></div>
            </div>
        </template>
        <template v-else>
            <template v-if="isWithAdmin">
                <div style="display: flex; align-items: center; margin-top: 20px; position: relative; justify-content: space-between; padding-bottom: 11px;">
                    <div style="flex:1; display:flex; align-items: center; " @click="() => { $GlobalStore.closeLastModal() }">
                        <img :src="require('@/assets/images/mypage/ico-move.png')" style="width: 10px; transform: rotate(180deg);margin-left: 20px;">
                        <span style="font-size:14px; font-weight:500; margin-left:5px; color:#210F03;">뒤로가기</span>
                    </div>
                    <div @click="setIsShowCalendar" style="display:flex;flex-direction: column;justify-content: center; align-items: center; position: absolute; left: 50%; transform: translateX(-50%); font-weight:bold; font-size:16px;">
                        <div style="font-size:16px; color:#210F03; max-width:150px; overflow:hidden;text-overflow: ellipsis; white-space: nowrap;">사커하우 고객지원</div>
                    </div>
                    <div style="flex:1; display:flex; flex-direction: row-reverse; gap: 4px; position: relative; padding-right: 12px;"></div>
                </div>
            </template>
            <template v-else>
                <div style="position: relative; z-index: 10; display:flex; justify-content: center; padding-top: 8px; background-color: white; align-items: flex-end; padding-bottom:12px; border-bottom: 1px solid #f5f5f5;">
                    <div style="flex:1; display:flex; align-items: center; " @click="() => { $GlobalStore.closeLastModal() }">
                        <img :src="require('@/assets/images/mypage/ico-move.png')" style="width: 10px; transform: rotate(180deg);margin-left: 20px;">
                        <span style="font-size:14px; font-weight:500; margin-left:5px; color:#210F03;">뒤로가기</span>
                    </div>
                    <div style="display:flex;flex-direction: column;justify-content: center; align-items: center;font-weight:bold; font-size:16px; position: absolute; left: 50%; transform: translateX(-50%)">
                        <div v-if="chat.type == JOIN_CHAT_TYPE.CHAT_WITH_COACH && single_opponent_member.is_coach != 0" style="font-size:16px; color:#210F03; margin-top:3px; max-width:150px; overflow:hidden;text-overflow: ellipsis; white-space: nowrap;">{{ title }}</div>
                        <div style="display: flex; align-items: center; gap: 4px;" v-else>
                            <div>{{ title }} <span style="font-weight: 700; color: var(--color-main);">{{ single_opponent_member.position }}</span></div>
                        </div>
                    </div>
                    <div style="flex:1; display:flex; flex-direction: row-reverse; position: relative">
                        <div @click="showPersonalChatSetting" style="display: flex; align-items: center; gap: 4px; padding-right: 12px;">
                            <div style="width: 8px; height: 8px; border-radius: 50%; background-color: #210f03;"></div>
                            <div style="width: 8px; height: 8px; border-radius: 50%; background-color: #210f03;"></div>
                            <div style="width: 8px; height: 8px; border-radius: 50%; background-color: #210f03;"></div>
                        </div>
                    </div>
                </div>
            </template>
        </template>
        <template v-if="chat.type == JOIN_CHAT_TYPE.OPEN && chatHistoies.length === 0">
            <div style="padding:20px 0px; text-align:center;">
                <div style="padding:5px 20px;color:#606060; font-weight:500; border-radius:11px; font-size: 12px; display:inline-block; background-color: white;">오늘</div>
                <div style="font-size: 12px; color: #808080; line-height: 18px;" v-if="isShowWelcomeMessage">{{ openMemberTalkInfo.region }} 오픈 멤버톡에 들어왔습니다.<br>다양한 회원들과 자유롭게 소통할 수 있습니다.</div>
            </div>
        </template>
        <template v-if="Object.keys(directMessageInfo).length >= 1 && !isFocus">
            <div style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); padding: 12px; border-radius: 24px;">
                <div style="background: #210F031A; padding: 12px; border-radius: 12px;">
                    <div style="font-weight: 700; font-size: 14px;">진행 현황</div>
                    <div style="margin-top: 20px; margin-bottom: 30px">
                        <div style="background: #FFFFFF66; height: 4px; border-radius: 2px; display: flex;;">
                            <div :class="requestStatus >= DIRECT_MESSAGE_STATUS.REQUEST_SEND ? 'circle_wrap_active' : ''" class="circle_wrap" style="flex-basis: 8%; border-top-right-radius: 0; border-bottom-right-radius: 0;"></div>
                            <div :class="requestStatus >= DIRECT_MESSAGE_STATUS.RESERVE_TEST_DATE ? 'circle_wrap_active' : ''" class="circle_wrap" style="flex-basis: 13%; border-top-left-radius: 0; border-bottom-left-radius: 0;">
                                <div :class="requestStatus >= DIRECT_MESSAGE_STATUS.RESERVE_TEST_DATE ? 'inner_circle_active' : ''" class="inner_circle">
                                    <div :class="requestStatus >= DIRECT_MESSAGE_STATUS.RESERVE_TEST_DATE ? 'circle_text_active' : ''" class="circle_text">입단 테스트 일정 잡기</div>
                                </div>
                            </div>
                            <div :class="requestStatus >= DIRECT_MESSAGE_STATUS.PROGRESSING_TEST ? 'circle_wrap_active' : ''" class="circle_wrap" style="flex-basis: 36%;">
                                <div :class="requestStatus >= DIRECT_MESSAGE_STATUS.PROGRESSING_TEST ? 'inner_circle_active' : ''" class="inner_circle">
                                    <div :class="requestStatus >= DIRECT_MESSAGE_STATUS.PROGRESSING_TEST ? 'circle_text_active' : ''" class="circle_text">입단 테스트 진행</div>
                                </div>
                            </div>
                            <div :class="requestStatus >= DIRECT_MESSAGE_STATUS.ANNOUNCE_RESULT ? 'circle_wrap_active' : ''" class="circle_wrap" style="flex-basis: 27%;">
                                <div :class="requestStatus >= DIRECT_MESSAGE_STATUS.ANNOUNCE_RESULT ? 'inner_circle_active' : ''" class="inner_circle">
                                    <div :class="requestStatus >= DIRECT_MESSAGE_STATUS.ANNOUNCE_RESULT ? 'circle_text_active' : ''" class="circle_text">결과 안내</div>
                                </div>
                            </div>
                            <div :class="requestStatus >= DIRECT_MESSAGE_STATUS.ANNOUNCE_RESULT ? 'circle_wrap_active' : ''" class="circle_wrap" style="flex: 1;"></div>
                        </div>
                    </div>
                </div>
                <div @click="setIsShowCalendar" style="border: 1px solid #949494; border-radius: 12px; padding: 12px; margin-top: 10px;">
                    <div style="display: flex; align-items: center; gap: 4px;">
                        <div>
                            <img style="width: 29px;" :src="require('@/assets/img/calendar_chat.png')" alt="">
                        </div>
                        <div style="font-weight: 500; font-size: 14px; position: relative;">
                            <div>입단 테스트 일정 잡기</div>
                            <div v-if="isShowSpeechBubble" @click="closePopup" style="position: absolute; background: #fff; padding: 2px 8px; right: -196px; top: -31px; display: flex; align-items: center; gap: 4px; border-radius: 16px; border-bottom-left-radius: 0;">
                                <div style="font-size: 12px; line-height: 24px; font-weight: 500;">일정을 등록하면 선수에게 등록이 됩니다</div>
                                <div>
                                    <img style="width: 10px;" :src="require('@/assets/img/search_x_btn.png')" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex; gap: 26px; margin-top: 24px;">
                        <div style="padding-left: 9px; font-weight: 700; font-size: 20px; font-style: italic; color: var(--color-main);">{{ month }}</div>
                        <div style="flex: 1; display: flex; justify-content: space-between; margin-top: 5px; padding-right: 14px;">
                            <div style="display: flex; flex-direction: column; align-items: center; gap: 13px;" v-for="each, i in testCalendar" :key="i + 'day'">
                                <div style="font-weight: 400; font-size: 12px;" :style="{ color: each.isWeekend ? '#fa1717' : '' }">{{ each.day }}</div>
                                <div v-if="!isConfirmedTestDay" style="font-weight: 400; font-size: 12px; padding-bottom: 4px;" :style="{ color: each.isWeekend ? '#fa1717' : '', borderBottom: each.date === today ? '1px solid #210f03' : '' }">{{ each.date.split('-')[2] }}</div>
                                <div v-else style="font-weight: 400; font-size: 12px; padding-bottom: 4px; padding: 12px; border-radius: 4px; position: relative" :style="{ color: transFontColor(each.isWeekend, each.date), backgroundColor: each.date === selectedTestDate.date ? 'var(--color-main)' : '' }">
                                    <div>{{ each.date.split('-')[2] }}</div>
                                    <div v-if="each.date === selectedTestDate.date" style="position: absolute; top: -5px; left: -5px;">
                                        <img style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <div style="flex:1; overflow:auto;padding:0px 10px; padding-bottom: 12px; position: relative;" @scroll="throttleScroll($event)" ref="scrollWrap">
            <template v-if="chatHistoies.length === 0 && (chat.type == JOIN_CHAT_TYPE.SINGLE || chat.type == JOIN_CHAT_TYPE.CHAT_WITH_COACH)">
                <div>
                    <div style="padding:20px 0px; text-align:center;">
                        <div style="padding:5px 20px;color:#606060; font-weight:500; border-radius:11px; font-size: 12px; display:inline-block; background-color: white;">{{ $Util.getMMDDDayHangulStr(chat.insert_date) }}</div>
                    </div>
                    <div v-if="chat.type != JOIN_CHAT_TYPE.SINGLE" style="padding: 20px; background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); height: 231px; border-radius: 24px;">
                        <div style="text-align: center; line-height: 20px; font-weight: 700;">채팅이 열렸습니다</div>
                        <div style="display: flex; margin-top: 12px; align-items: center; justify-content: space-between;">
                            <div style="display: flex; flex-direction: column; align-items: center;">
                                <ProfileImage style="width: 100px;" :imagePath="myImagePath" :is-show-border="false"></ProfileImage>
                                <template v-if="$GlobalStore.loginInfo().is_coach == '0'">
                                    <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px;">
                                        <div style="font-weight: 700; font-size: 12px; line-height: 16px;">{{ user.nic_name }}</div>
                                        <div style="font-size: 11px; font-weight: 900; color: var(--color-main);">{{ $GlobalStore.loginInfo().position }}</div>
                                    </div>
                                    <div style="font-size: 11px; font-weight: 500; color: #808080;margin-top:3px;">&nbsp;</div>
                                </template>
                                <template v-else>
                                    <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px;">
                                        <div style="font-weight: 700; font-size: 12px; line-height: 16px;">{{ user.nic_name }}</div>
                                        <img v-if="user.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                        <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                    </div>
                                    <div style="font-size: 11px; font-weight: 500; color: #808080;margin-top:3px;">{{ user.team_name }}</div>
                                </template>
                            </div>
                            <div style="display: flex; gap: 4px;">
                                <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                                <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                                <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                                <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                                <div style="width: 6px; height: 6px; border-radius: 50%; background-color: #d9d9d9;"></div>
                            </div>
                            <div style="display: flex; flex-direction: column; align-items: center;">
                                <ProfileImage :imagePath="opponent_image_path" :is-show-border="false" style="width: 100px;"></ProfileImage>
                                <template v-if="single_opponent_member.is_coach == '0'">
                                    <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px;">
                                        <div style="font-weight: 700; font-size: 12px; line-height: 16px;">{{ single_opponent_member.nic_name }} </div>
                                        <div style="font-size: 11px; font-weight: 900; color: var(--color-main);">{{ single_opponent_member.position }}</div>
                                    </div>
                                    <div style="font-size: 11px; font-weight: 500; color: #808080;margin-top:3px;">&nbsp;</div>
                                </template>
                                <template v-else>
                                    <div style="display: flex; align-items: center; gap: 4px; margin-top: 4px;">
                                        <div style="font-weight: 700; font-size: 12px; line-height: 16px;">{{ single_opponent_member.nic_name }}</div>
                                        <img v-if="single_opponent_member.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                                        <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
                                    </div>
                                    <div style="font-size: 11px; font-weight: 500; color: #808080; margin-top:3px;">{{ single_opponent_member.team_name }}</div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div @click="sayHello" style="width: 238px; line-height: 62px; color: #fff; font-size: 15px; font-weight: 500; text-align: center; height: 62px; border-radius: 22px; background-color: #210F03; margin: 0 auto; margin-top: 20px;">탭하고 먼저 인사하세요! 👋</div>
                </div>
            </template>
            <template v-for="each, i in chatHistoies">
                <div :key="'b_1' + each.idx">
                    <!-- 여기까지 읽음 표시-->
                    <div v-if="each.type == JOIN_CHAT_HISTORY_TYPE.CHAT_FOR_COACH_CERT_LOGO" style="text-align: center; display: flex; flex-direction: column; align-items: center; margin-top: 20px;">
                        <div style="width: 100px; height: 100px; border-radius: 50%; display: flex; justify-content: center; align-items: center; background-color: var(--color-main);">
                            <img style="width: 55px;" :src="require('@/assets/lesson_emblem.png')" alt="">
                        </div>
                        <div style="margin-top: 8px; font-weight: 700; font-size: 14px; line-height: 24px;">전문가 등록 지원</div>
                    </div>
                    <!-- 날짜 -->
                    <div v-if="i === 0 || (chatHistoies[i - 1].insert_date.substr(0, 10) !== chatHistoies[i].insert_date.substr(0, 10))" style="padding:20px 0px; text-align:center;">
                        <div style="padding:5px 20px;color:#606060; font-weight:500; border-radius:11px; font-size: 12px; display:inline-block; background-color: white;">{{ each.insert_date.substr(0, 10) === today ? '오늘' : $Util.getMMDDDayHangulStr(each.insert_date) }}</div>
                        <div style="font-size: 12px; color: #808080; line-height: 18px;" v-if="isShowWelcomeMessage && i === 0 && chat.type == JOIN_CHAT_TYPE.OPEN">{{ openMemberTalkInfo.region }} 오픈 멤버톡에 들어왔습니다.<br>다양한 회원들과 자유롭게 소통할 수 있습니다.</div>
                    </div>
                </div>
                <template v-if="each.type === JOIN_CHAT_HISTORY_TYPE.ASK_TO_ADMIN_LOGO">
                    <div style="" :key="'a1' + each.idx">
                        <div style="display:grid;place-items: center;">
                            <img :src="require('@/assets/img/chat_logo.png')" style="width:100px; height:100px; border-radius:50%;">
                            <div style="color:#210F03; font-size:14px; font-weight:bold; margin-top:12px;">사커하우 매니저</div>
                        </div>
                        <div style="margin-top:25px; text-align:center; color:#210F03; font-size:12px; font-weight:500;">{{ $Util.getMMDDDayHangulStr(each.insert_date) }}</div>
                    </div>
                </template>
                <template v-if="each.type === JOIN_CHAT_HISTORY_TYPE.ASK_TO_ADMIN_INTRODUCE_FORM">
                    <div :key="'a1' + each.idx" v-if="myMemberIdx != each.member_idx">
                        <div style="height:30px;"></div>
                        <div style="display:flex; align-items: center; position:relative; ">
                            <img :src="require('@/assets/img/chat_logo.png')" style="position:absolute; left:0px; top:0px;width:40px;height:40px;border-radius: 50%;">
                            <span style="margin-left:50px; font-size:12px; font-weight:bold; color:#555555;">{{ each.nic_name }}</span>
                        </div>
                    </div>

                    <!-- 본인 -->
                    <div :key="'a2' + each.idx" class="ballon_wrap" v-if="myMemberIdx == each.member_idx" style="text-align:right;">
                        <div class="ballon" style="max-width:90%; background-color: #FFA011; color:#210f03; text-align:left;white-space: pre-wrap; word-break: break-word; font-size:15px; line-height: 20px; font-weight:500; border-top-right-radius:0px;">
                            <span>{{ chat_form_text }}</span>
                            <div style="padding:15px;" v-if="is_chat_form_input_show">
                                <div style=""><input type="text" class="chat_form_input" placeholder="이름" readonly v-model="chat_form_name"></div>
                                <div style="margin-top:12px;"><input type="text" class="chat_form_input" placeholder="연락처" readonly v-model="chat_form_phone"></div>
                            </div>
                        </div>
                        <div style="color:#808080; font-size:12px; font-weight:500; margin-top:5px; margin-right:10px;" v-if="chatHistoryCnt - 1 === i || (chatHistoryCnt > i && chatHistoies[i + 1].member_idx !== each.member_idx) || (chatHistoryCnt > i && chatHistoies[i + 1].type !== JOIN_CHAT_HISTORY_TYPE.NORMAL)">{{ each.insert_date | chatTimeStr }}</div>
                    </div>
                    <!-- 타인 -->
                    <div :key="'a3' + each.idx" class="ballon_wrap" style="padding-left:50px;" v-else>

                        <div class="ballon" style="max-width:90%; background-color: #F5F5F5; white-space: pre-wrap; word-break: break-word; font-size:15px; line-height: 20px; font-weight:500;  border-top-left-radius:0px;">
                            <span>{{ chat_form_text }}</span>
                            <div style="padding:15px;" v-if="is_chat_form_input_show">
                                <div style=""><input type="text" class="chat_form_input" placeholder="이름" v-model="chat_form_name" :readonly="$GlobalStore.isLogin() || is_chat_form_complete"></div>
                                <div style="margin-top:12px;"><input type="text" class="chat_form_input" ref="chat_form_input_phone" placeholder="연락처" v-model="chat_form_phone" :readonly="$GlobalStore.isLogin() || is_chat_form_complete"></div>
                                <div style="margin-top:12px;" class="chat_form_input_confirm_btn" :class="[chat_form_phone.length > 0 && chat_form_name.length > 0 ? 'active' : '']" @click="saveChatForm" v-if="!$GlobalStore.isLogin() && !is_chat_form_complete">확인</div>
                            </div>
                        </div>
                        <div style="color:#808080; font-size:12px; font-weight:500; margin-top:5px; margin-left:10px;" v-if="chatHistoryCnt - 1 === i || (chatHistoryCnt > i && chatHistoies[i + 1].member_idx !== each.member_idx) || (chatHistoryCnt > i && chatHistoies[i + 1].type !== JOIN_CHAT_HISTORY_TYPE.NORMAL)">{{ each.insert_date | chatTimeStr }}</div>
                    </div>

                </template>

                <template>
                    <div style="" :key="'b' + each.idx">
                        <template v-if="each.type === JOIN_CHAT_HISTORY_TYPE.MEMBER_TALK_JOINED">
                            <div class="member_talk_chat_wrap" style="" v-if="!$GlobalStore.checkIsMe(each.member_idx, each.member_type)">
                                <div class="member_talk_chat_ball" style=""></div>
                                <div class="member_talk_chat_sentence" style="">{{ each.contents }}님이 멤버로 참여합니다.</div>
                            </div>
                        </template>
                        <template v-else-if="each.type === JOIN_CHAT_HISTORY_TYPE.MEMBER_TALK_SETTING_CHANGED">
                            <div class="member_talk_chat_wrap" :style="{ flexDirection: $GlobalStore.checkIsMe(each.member_idx, each.member_type) ? 'row-reverse' : 'row' }">
                                <div class="member_talk_chat_ball"></div>
                                <div class="member_talk_chat_sentence" style="">멤버톡 설정{{ $GlobalStore.checkIsMe(each.member_idx, each.member_type) ? '을 변경했습니다.' : '이 변경됐습니다.' }}</div>
                            </div>
                        </template>
                        <template v-else-if="each.type === JOIN_CHAT_HISTORY_TYPE.MEMBER_TALK_KICK_OUT">
                            <div class="member_talk_chat_wrap" :style="{ flexDirection: $GlobalStore.checkIsMe(each.member_idx, each.member_type) ? 'row-reverse' : 'row' }">
                                <div class="member_talk_chat_ball"></div>
                                <div class="member_talk_chat_sentence" style="">{{ each.contents }}{{ $GlobalStore.checkIsMe(each.member_idx, each.member_type) ? '님을 방출했습니다.' : '님이 방출됐습니다.' }}</div>
                            </div>
                        </template>
                        <template v-else-if="each.type === JOIN_CHAT_HISTORY_TYPE.MEMBER_TALK_GET_OUT">
                            <div class="member_talk_chat_wrap" style="" v-if="!$GlobalStore.checkIsMe(each.member_idx, each.member_type)">
                                <div class="member_talk_chat_ball" style=""></div>
                                <div class="member_talk_chat_sentence" style="">{{ each.contents }}님이 나갔습니다.</div>
                            </div>
                        </template>

                        <template v-if="myMemberIdx != each.member_idx
                            && (i === 0
                                || (
                                    each.member_idx !== chatHistoies[i - 1].member_idx
                                    || (each.member_idx === chatHistoies[i - 1].member_idx && chatHistoies[i - 1].type === JOIN_CHAT_HISTORY_TYPE.ASK_TO_ADMIN_INTRODUCE_FORM)
                                    || (each.member_idx === chatHistoies[i - 1].member_idx && chatHistoies[i - 1].insert_date.substr(0, 10) !== chatHistoies[i].insert_date.substr(0, 10))
                                )
                            )
                            && (each.type === JOIN_CHAT_HISTORY_TYPE.NORMAL
                                || each.type === JOIN_CHAT_HISTORY_TYPE.MERCENARY_REFRESH_NORMAL
                                || each.type === JOIN_CHAT_HISTORY_TYPE.IMAGE
                                || each.type === JOIN_CHAT_HISTORY_TYPE.RESERVE_TEST_DATE
                                || each.type === JOIN_CHAT_HISTORY_TYPE.FEEDBACK_CONTENTS
                            )">
                            <div style="height:30px;"></div>
                            <div style="display:flex; align-items: center; position:relative; ">
                                <img :src="each.image_path ? $resourcePath + each.image_path : require('@/assets/profile.png')" style="position:absolute; left:0px; top:0px;width:40px;height:40px;border-radius: 50%;" @error="(e) => { e.target.src = require('@/assets/profile.png') }" @click="showProfile(each.member_type, each.member_idx)">
                                <span style="margin-left:50px; font-size:12px; font-weight:bold; color:#555555;">{{ each.nic_name }}</span>
                            </div>
                        </template>
                        <template v-if="myMemberIdx != each.member_idx && each.type === 71">
                            <!-- <div style="height:30px;"></div> -->
                            <div style="display:flex; align-items: center; position:relative; ">
                                <img :src="each.image_path ? $resourcePath + each.image_path : require('@/assets/profile.png')" style="position:absolute; left:0px; top:0px;width:40px;height:40px;border-radius: 50%;" @error="(e) => { e.target.src = require('@/assets/profile.png') }" @click="showProfile(each.member_type, each.member_idx)">
                                <span style="margin-left:50px; font-size:12px; font-weight:bold; color:#555555;">{{ each.nic_name }}</span>
                            </div>
                        </template>
                        <template v-if="each.type == JOIN_CHAT_HISTORY_TYPE.CHAT_FOR_COACH_CERT_FORM">
                            <div style="padding-left: 50px;" class="ballon_wrap">
                                <div class="ballon" style="background-color: #F5F5F5; max-width: 85%; white-space: pre-wrap; word-break: break-word; font-size:14px; line-height: 20px; font-weight:500;  border-top-left-radius:0px;">
                                    <div style="line-height: 24px;">안녕하세요, 사커하우 고객지원입니다. 전문가 회원으로 가입해주셔서 감사합니다. 아래에 표시된 서류들을 첨부해주세요! 검토 후 전문가 등록을 도와드리겠습니다 😊</div>
                                    <div style="margin-top: 20px; padding: 0 14px;">
                                        <div style="display: flex; align-items: center; gap: 10px;">
                                            <div style="width: 4px; height: 4px; background-color: #210f03; border-radius: 50%;"></div>
                                            <div style="font-weight: 700; font-size: 14px; line-height: 24px;">[필수] 주민등록증 사본</div>
                                        </div>
                                        <div v-if="!member_doc || member_doc.personal_doc_confirmed == '0'" style="background-color: #fff; height: 40px; line-height: 40px; text-align: center; border-radius: 40px; margin-top: 4px; color: #5c9dff; font-size: 14px; font-weight: 500;" @click="showFileSelector('personal')">파일 첨부하기</div>
                                        <div v-else style="background-color: #dcdcdc; height: 40px; line-height: 40px; text-align: center; border-radius: 40px; margin-top: 4px; color: #5c9dff; font-size: 14px; font-weight: 500;">인증완료</div>
                                    </div>
                                    <div style="margin-top: 20px; padding: 0 14px; padding-bottom: 15px;">
                                        <div style="display: flex; align-items: center; gap: 10px;">
                                            <div style="width: 4px; height: 4px; background-color: #210f03; border-radius: 50%;"></div>
                                            <div style="font-weight: 700; font-size: 14px; line-height: 24px;">[필수] 조인KFA 선수 경력 증명서 또는 지도자 자격증</div>
                                        </div>
                                        <div v-if="!member_doc || member_doc.player_cert_confirmed == '0'" style="background-color: #fff; height: 40px; line-height: 40px; text-align: center; border-radius: 40px; margin-top: 4px; color: #5c9dff; font-size: 14px; font-weight: 500;" @click="showFileSelector('player')">파일 첨부하기</div>
                                        <div v-else style="background-color: #dcdcdc; height: 40px; line-height: 40px; text-align: center; border-radius: 40px; margin-top: 4px; color: #5c9dff; font-size: 14px; font-weight: 500;">인증완료</div>
                                    </div>
                                </div>
                                <div style="display:inline-block; vertical-align: bottom; font-size:12px;padding-bottom:2px;padding-left:5px;">
                                    <div style="font-weight:bold;font-size:12px;color:#ff6100; margin-bottom:3px;">{{ each.read_count > 0 ? each.read_count : '' }}</div>
                                </div>

                                <div style="color:#808080; font-size:12px; font-weight:500; margin-top:5px; margin-left:10px;" v-if="chatHistoryCnt - 1 === i || (chatHistoryCnt > i && chatHistoies[i + 1].member_idx !== each.member_idx) || (chatHistoryCnt > i && chatHistoies[i + 1].type !== JOIN_CHAT_HISTORY_TYPE.NORMAL)">{{ each.insert_date | chatTimeStr }}</div>
                            </div>
                        </template>
                        <template v-if="each.type === JOIN_CHAT_HISTORY_TYPE.NORMAL || each.type === JOIN_CHAT_HISTORY_TYPE.MERCENARY_REFRESH_NORMAL">
                            <!-- 본인 -->
                            <div class="ballon_wrap" v-if="myMemberIdx == each.member_idx" style="text-align:right;">
                                <div v-if="chat.type != JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT && !isWithAdmin" style="display:inline-block; vertical-align: bottom;font-size:12px;padding-bottom:2px;padding-right:5px;">
                                    <div style="font-weight:bold; font-size:12px;color:#ff6100; margin-bottom:3px;">{{ each.read_count > 0 ? each.read_count : '' }}</div>
                                </div>
                                <div class="ballon" style="background-color: #FFA011; color:#210f03; text-align:left;white-space: pre-wrap; word-break: break-word; font-size:15px; line-height: 20px; font-weight:500; border-top-right-radius:0px;">
                                    <JoinChatContents :contents="each.contents" />
                                </div>

                                <div style="color:#808080; font-size:12px; font-weight:500; margin-top:5px; margin-right:10px;" v-if="chatHistoryCnt - 1 === i || (chatHistoryCnt > i && chatHistoies[i + 1].member_idx !== each.member_idx) || (chatHistoryCnt > i && chatHistoies[i + 1].type !== JOIN_CHAT_HISTORY_TYPE.NORMAL)">{{ each.insert_date | chatTimeStr }}</div>
                            </div>
                            <!-- 타인 -->
                            <div class="ballon_wrap" style="padding-left:50px;" v-else>
                                <div class="ballon" style="background-color: #F5F5F5; white-space: pre-wrap; word-break: break-word; font-size:15px; line-height: 20px; font-weight:500;  border-top-left-radius:0px;">
                                    <JoinChatContents :contents="each.contents" />
                                </div>
                                <div style="display:inline-block; vertical-align: bottom; font-size:12px;padding-bottom:2px;padding-left:5px;">
                                    <div style="font-weight:bold;font-size:12px;color:#ff6100; margin-bottom:3px;">{{ each.read_count > 0 ? each.read_count : '' }}</div>
                                </div>

                                <div style="color:#808080; font-size:12px; font-weight:500; margin-top:5px; margin-left:10px;" v-if="chatHistoryCnt - 1 === i || (chatHistoryCnt > i && chatHistoies[i + 1].member_idx !== each.member_idx) || (chatHistoryCnt > i && chatHistoies[i + 1].type !== JOIN_CHAT_HISTORY_TYPE.NORMAL)">{{ each.insert_date | chatTimeStr }}</div>
                            </div>

                            <div v-if="each.youtube_url_type && each.youtube_url_key" style="margin-top:10px;">
                                <div :style="{ textAlign: myMemberIdx == each.member_idx ? 'right' : '', paddingLeft: myMemberIdx == each.member_idx ? '' : '50px' }">
                                    <div v-if="each.youtube_url_type === 'be' || each.youtube_url_type === 'watch'" style="width:80%; display:inline-block; position:relative;">
                                        <iframe :src="'https://www.youtube.com/embed/' + each.youtube_url_key" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width:100%;border-radius:15px;">
                                        </iframe>
                                        <div style="position:absolute; bottom:4px;font-weight:bold; font-size:12px;color:#ff6100;" :style="{ right: myMemberIdx == each.member_idx ? null : '-12px', left: myMemberIdx == each.member_idx ? '-12px' : null }">{{ each.read_count }}</div>
                                    </div>
                                    <div v-else-if="each.youtube_url_type === 'shorts'" style="width:80%; height: 80vw; display:inline-block;position:relative;">
                                        <iframe :src="'https://www.youtube.com/embed/' + each.youtube_url_key" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="width:100%; height:100%; border-radius:15px;">
                                        </iframe>
                                        <div style="position:absolute; bottom:4px;font-weight:bold; font-size:12px;color:#ff6100;" :style="{ right: myMemberIdx == each.member_idx ? null : '-12px', left: myMemberIdx == each.member_idx ? '-12px' : null }">{{ each.read_count }}</div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- 본인 -->
                        <template v-else-if="each.type === JOIN_CHAT_HISTORY_TYPE.IMAGE">
                            <div :style="{ textAlign: myMemberIdx == each.member_idx ? 'right' : 'left' }">
                                <div style="margin-top:10px; padding:0px 0px 0px 20px; font-size:0px; position:relative; display:inline-block" :set="imagePathArr = each.contents.split('::')" :style="{ marginLeft: myMemberIdx == each.member_idx ? '' : '30px' }">
                                    <img :src="$resourcePath + imagePathArr[0]" style="width:160px; filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.25));border-radius: 15px;" :style="{ height: parseInt((160 / parseFloat(imagePathArr[1]))) + 'px' }" :image_path="imagePathArr[0]" @click="showImageViewer($event)">
                                    <div v-if="each.read_count && each.read_count > 0" style="position:absolute;  bottom:3px;font-weight:bold; font-size:12px;color:#ff6100;" :style="{ right: myMemberIdx == each.member_idx ? null : '-12px', left: myMemberIdx == each.member_idx ? '8px' : null }">{{ each.read_count }}</div>
                                </div>
                            </div>
                        </template>
                        <template v-else-if="each.type === JOIN_CHAT_HISTORY_TYPE.RESERVE_TEST_DATE">
                            <!-- 본인 -->
                            <div class="ballon_wrap" v-if="myMemberIdx == each.member_idx" style="text-align:right;">
                                <div v-if="chat.type != JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT" style="display:inline-block; vertical-align: bottom;font-size:12px;padding-bottom:2px;padding-right:5px;">
                                    <div style="font-weight:bold; font-size:12px;color:#ff6100; margin-bottom:3px;">{{ each.read_count > 0 ? each.read_count : '' }}</div>
                                </div>

                                <div class="ballon" style="max-width: 70%; background-color: #FFA011; color:#210f03; text-align:left;white-space: pre-wrap; word-break: break-word; font-size:15px; line-height: 20px; font-weight:500; border-top-right-radius:0px;">
                                    <div style="line-height: 20px; padding-bottom: 5px; font-size: 13px; font-weight: 700; border-bottom: 2px solid #716C6C3B">{{ each.contents.split('@||')[0] }}</div>
                                    <div style="font-size: 15px; padding-top: 5px; color: #fff; line-height: 20px;">{{ each.contents.split('@||')[1] }}</div>
                                    <div style="text-align: right; margin-top: 4px; font-size: 12px; color: #fff; padding-bottom: 6px;">{{ each.contents.split('@||')[2] }}</div>
                                </div>

                                <div style="color:#808080; font-size:12px; font-weight:500; margin-top:5px; margin-right:10px;" v-if="chatHistoryCnt - 1 === i || (chatHistoryCnt > i && chatHistoies[i + 1].member_idx !== each.member_idx) || (chatHistoryCnt > i && chatHistoies[i + 1].type !== JOIN_CHAT_HISTORY_TYPE.NORMAL)">{{ each.insert_date | chatTimeStr }}</div>
                            </div>
                            <!-- 타인 -->
                            <div class="ballon_wrap" style="padding-left:50px;" v-else>
                                <div class="ballon" style="background-color: #F5F5F5; max-width: 70%; white-space: pre-wrap; word-break: break-word; font-size:15px; line-height: 20px; font-weight:500;  border-top-left-radius:0px;">
                                    <div style="line-height: 20px; padding-bottom: 5px; font-size: 13px; color: var(--color-main); font-weight: 700; border-bottom: 2px solid #716C6C3B">{{ each.contents.split('@||')[0] }}</div>
                                    <div style="font-size: 15px; padding-top: 5px; line-height: 20px;">{{ each.contents.split('@||')[1] }}</div>
                                    <div style="margin-top: 4px; font-size: 12px; padding-bottom: 6px; text-align: right;">{{ each.contents.split('@||')[2] }}</div>
                                </div>
                                <div style="display:inline-block; vertical-align: bottom; font-size:12px;padding-bottom:2px;padding-left:5px;">
                                    <div style="font-weight:bold;font-size:12px;color:#ff6100; margin-bottom:3px;">{{ each.read_count > 0 ? each.read_count : '' }}</div>
                                </div>

                                <div style="color:#808080; font-size:12px; font-weight:500; margin-top:5px; margin-left:10px;" v-if="chatHistoryCnt - 1 === i || (chatHistoryCnt > i && chatHistoies[i + 1].member_idx !== each.member_idx) || (chatHistoryCnt > i && chatHistoies[i + 1].type !== JOIN_CHAT_HISTORY_TYPE.NORMAL)">{{ each.insert_date | chatTimeStr }}</div>
                            </div>
                        </template>
                        <template v-else-if="each.type === JOIN_CHAT_HISTORY_TYPE.FEEDBACK_CONTENTS">
                            <template v-if="!$hasOwnProperty(feedbacks, each.contents + '')">{{setFeedbackSoccerhow(each.contents + '') ? '' : ''}}</template>
                            <div style="padding-left: 50px; max-width: 64%;">
                                <div @click="showTrainingVideoDetail(feedbacks[each.contents].idx)" style="background: linear-gradient(90deg, rgba(255, 113, 17, 0.1) 0%, rgba(33, 15, 3, 0.1) 100%); border-radius: 12px; border-top-left-radius: 0; padding: 6px; margin-top: 10px;">
                                    <div style="font-weight: 500; font-size: 15px; line-height: 18px;">{{feedbacks[each.contents] ? feedbacks[each.contents].contents : ''}}</div>
                                    <div style="display: flex; overflow-x: scroll; gap: 6px; margin: 0 -6px; padding: 0 6px; margin-top: 6px;">
                                        <div v-for="imgItem, i in feedbacks[each.contents].imgSrcArr" :key="i + 'imgItem'" style="border-radius: 6px; flex-shrink: 0; width: 150px; height: 100px; overflow: hidden;">
                                            <template v-if="!imgItem.videoPath.isVideo">
                                                <img style="object-fit: cover; width: 100%; height: 100%; border-radius: 6px;" :src="imgItem.path">
                                            </template>
                                            <div style="position: relative; width: 100%; height: 100%;" v-else>
                                                <img style="object-fit: cover; width: 100%; height: 100%;" :ref="'img' + i" :src="$resourcePath + imgItem.videoPath.thumbnail_path">
                                                <div style="position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);">
                                                    <img style="width: 40px;" :src="require('@/assets/video_play_icon.png')" alt="">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="display: flex; margin-top: 8px; margin-left: 14px; gap: 8px; padding-bottom: 10px;">
                                        <div style="display: flex; gap: 5px; align-items: center; ">
                                            <div style="position: relative;">
                                                <img style="width: 12px; position: relative; z-index: 2;" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt="">
                                            </div>
                                            <div style="font-weight: 700; font-size: 12px;">{{ feedbacks[each.contents].like_number }}</div>
                                        </div>
                                        <div style="display: flex; gap: 5px; align-items: center;">
                                            <img style="width: 12px;" :src="require('@/assets/img/feed_reply.png')" alt="">
                                            <div style="font-weight: 700; font-size: 12px;">{{ feedbacks[each.contents].reply_number }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </template>
            </template>

            <div style="height:20px;"></div>
            <CommonPopupFrame :changeHeight="100" :isOpen="isShowCalendar" :closeCompleteAction="closeCalendar" :changeBottom="0">
                <div @touchstart.stop="() => { }" @touchend.stop="() => { }" @touchmove.stop="() => { }" style="padding: 0 12px; flex: 1; overflow-y: scroll;">
                    <div @click="closeCalendar" style="padding: 16px 20px; padding-left: 12px; font-weight: 700; width: 100px;">닫기</div>
                    <div v-if="isShowContents">
                        <CalendarChat :selectDateCallBack="setDate"></CalendarChat>
                        <div style="margin-top: 12px;">
                            <TimeSelectorChat :closeAction="closeCalendar" :complete-action="setTime"></TimeSelectorChat>
                        </div>
                    </div>
                </div>
            </CommonPopupFrame>
        </div>
        <div v-if="isShowRejectedMessage && $GlobalStore.loginInfo().is_temp_coach == 1" :style="{bottom: navigation_bottom_height + 68 + 'px'}" style="position: absolute; display: flex; flex-direction: column; align-items: center; width: calc(100% - 40px);background: #F5F5F5E5; height: 97px; left: 50%; transform: translateX(-50%); border-radius: 12px; z-index: 1000;">
            <div style="position: relative; width: 100%;">
                <div @click="closeRejectedMessage" style="position: absolute; text-align: right; top: 4px; width: 100%; padding-right: 12px;">
                    <svg style="" width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.70369e-07 0.875L0.875 0L7 6.125L6.125 7L1.70369e-07 0.875Z" fill="#BBBBBB"/>
                        <path d="M6.125 0L7 0.875L0.875 7L0 6.125L6.125 0Z" fill="#BBBBBB"/>
                    </svg>
                </div>
                <div style="margin-top: 16px; text-align: center; font-size: 14px; font-weight: 700; line-height: 20px;">상대방이 소통 요청을 거절했습니다.</div>
                <div style="margin-top: 5px; line-height: 20px; font-size: 12px; font-weight: 500; color: #4b8aff; text-align: center;">💡 추후 해당 회원이 먼저 메시지를 보내올 경우,<br>대화방은 다시 정상적으로 활성화됩니다.</div>
            </div>
        </div>
        <div :style="{ height: (58 + (is_keyboard_up ? - ori_navigation_bottom_height : 0)) + 'px' }" style=""></div>
        <div style="position:absolute; left:0px; display:flex; width:100%; padding:8px 17px; align-items: center; background-color: white; border-top:1px solid #F5F5F5;" :style="{ bottom: navigation_bottom_height + 'px' }">
            <input type="file" style="display:none;" accept="image/*" ref="file1" @change="uploadCertFile">
            <input type="file" style="display:none;" accept="image/*" ref="file0" @change="uploadFile">
            <div style="margin-right:12px;display:grid;place-items: center; height: 40px; width:40px; border-radius:20px; background-color: #F5F5F5;" @click="showFile">
                <img v-if="is_disable_chat || is_chat_closed" :src="require('@/assets/img/chat_picture_plus.png')" style="width:20px; ">
                <img v-else :src="require('@/assets/img/chat_picture_plus.png')" style="width:20px; ">
            </div>
            <div style="flex:1; position: relative;">
                <textarea rows="1" style="flex:1; width: 100%; height:40px; background-color: #efefef; resize:none; outline: none; border:0px; padding:10px 15px; border-radius:20px; font-size:14px; line-height:20px; overflow:hidden; padding-right: 40px" v-model="msg" ref="contents" :placeholder="is_chat_closed ? '상담이 종료되었습니다.' : (is_disable_chat ? '대화할 수 없는 대상입니다.' : '')" @input="calcContentsLength($event)" :readonly="is_disable_chat || is_chat_closed" oninput='this.style.height = ""; this.style.height = (this.scrollHeight) + "px"' @keyup="enter($event)" @focus="detectTextAreaFocus" @blur="detectTextAreaBlur"></textarea>
                <div v-if="contentsLength === 0 || msg.trim() === ''" style="width: 35px; height: 35px; background-color:#D9D9D9; display: flex;border-radius: 50%; justify-content: center; align-items: center; position: absolute; right: 3px; top: 3px;">
                    <img :src="require('@/assets/img/chat_send_new.png')" style="width:12px; ">
                </div>
                <div v-else style="width: 35px; background-color: black;display: flex; align-items: center; justify-content: center; height: 35px; border-radius: 50%; position: absolute; right: 3px; top: 3px;" @click.stop="complete">
                    <img :src="require('@/assets/img/chat_send_new.png')" style="width:12px;">
                    <div style="position:absolute; left:-5px; top:-5px; width:100px; height:100px; " @click.stop="complete"></div>
                </div>
            </div>

            <template v-if="review_not_confirmed_schedule.length > 0">
                <template v-if="$GlobalStore.loginInfo().is_temp_coach == 1">
                    <div style="position:absolute; bottom:70px;left:0px; width:100%;padding:0px 20px;">
                        <div style="width:100%;background-color: #fbf6f2; padding:20px; border-radius:12px; position:relative;">
                            <div style="position:absolute; right:2px; top:-5px; padding:10px;" @click="saveReviewConfirmed">
                                <img :src="require('@/assets/img/x_btn_gray.png')" style="width:7px; height:7px;">
                            </div>
                            <div style="font-size:11px; text-align:center; color:#210F03;">트레이닝이 종료됐습니다. 받은 트레이닝 후기를 살펴보세요.</div>
                            <div style="display:grid; place-items: center;">
                                <div style="padding:0px 10px; font-weight:500; color:#4B8AFF; font-size:15px; margin-top:10px;" @click="showReviews">트레이닝 후기 보기</div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div style="position:absolute; bottom:70px;left:0px; width:100%;padding:0px 20px;">
                        <div style="width:100%;background-color: #fbf6f2; padding:20px; border-radius:12px; position:relative;">
                            <div style="position:absolute; right:2px; top:-5px; padding:10px;" @click="saveReviewConfirmed">
                                <img :src="require('@/assets/img/x_btn_gray.png')" style="width:7px; height:7px;">
                            </div>
                            <div style="font-size:11px; text-align:center; color:#210F03;">트레이닝이 종료됐습니다. 코치님이 트레이닝 후기를 기다리고 있어요.</div>
                            <div style="display:grid; place-items: center;">
                                <div style="padding:0px 10px; font-weight:500; color:#4B8AFF; font-size:15px; margin-top:10px;" @click="showReviewForm">트레이닝 후기 보내기</div>
                            </div>
                        </div>
                    </div>
                </template>
            </template>

        </div>

        <MemberTalkScheduleDetail :scheduleIdx="memberTalkScheduleIdx" :isOpen="isOpenMemberTalkScheduleDetail" :closeCompleteAction="() => { isOpenMemberTalkScheduleDetail = false }" />
        <MercenaryScheduleDetail :setCenter="setCenter" :scheduleDetailIdx="scheduleIdx" :isOpenScheduleDetail="isOpenScheduleDetail" :closeScheduleDetail="closeScheduleDetail"></MercenaryScheduleDetail>
        <BottomPopupMenu :is-open="isShowBottomPopMenu" :menu-options="menuOptions">
            <div class="each_menu" style="font-size: 14px; color:#210F03; padding-top: 12px; padding-bottom: 10px; text-align:center; ">
                <ProfileImage :imagePath="single_opponent_member.image_path" style="width: 100px"></ProfileImage>
                <div style="margin-top: 4px; line-height: 24px; font-weight: 700; font-size: 14px;">{{ single_opponent_member.nic_name }}<span style="color: var(--color-main); font-size: 12px; margin-left: 3px;">{{ single_opponent_member.position }}</span></div>
                <div style="color: #808080; line-height: 20px; font-size: 12px; font-weight: 500; margin-bottom: 20px;">친구</div>
                <div @click="$Util.showProfile(single_opponent_member.member_idx, single_opponent_member.member_type)" style="font-weight: 700; font-size: 14px; line-height: 24px;">프로필 보기</div>
            </div>
        </BottomPopupMenu>
    </div>
</template>

<script>
import io from 'socket.io-client';
import {
    JOIN_CHAT_HISTORY_TYPE,
    MEMBER_TYPE, DIRECT_MESSAGE_STATUS,
    JOIN_CHAT_TYPE, MAIN_TYPE,
    DUES_TYPE, DIRECT_MESSAGE_TYPE,
    JOIN_STATE, JOIN_MEMBER_STATE, JOIN_WAY, REVIEW_PAGE_TYPE, TEAM_TYPE
} from "../../Constants";

import moment from 'moment';
import ResponseCode from "../../ResponseCode";
import ProfileImage from "../common/ProfileImage";
import MemberTalkScheduleDetail from "./soccerjoin/MemberTalkScheduleDetail";
import MercenaryScheduleDetail from "@/components/common/MercenaryScheduleDetail"
import _ from 'lodash'
import BottomPopupMenu from '@/components/common/BottomPopupMenu'
import JoinChatContents from "../common/JoinChatContents";
import CalendarChat from "@/components/common/CalendarChat"
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import TimeSelectorChat from '@/components/common/TimeSelectorChat'

export const JOIN_CHAT_INIT_ACTION_TYPE = {
    DEFAULT: 0,
    MERCENARY_SCOUT_INIT: 1,
}

export default {
    name: "JoinChat",
    components: {
        JoinChatContents, CommonPopupFrame, TimeSelectorChat,
        MemberTalkScheduleDetail, MercenaryScheduleDetail, BottomPopupMenu,
        ProfileImage, CalendarChat
    },
    props: {
        auth: String,
        chatIdx: {
            type: [Number, String],
            default: -1,
        },
        completeAction: {
            type: Function,
            default: () => { }
        },
        chat: {
            type: Object,
            default: () => { }
        },
        pTitle: {
            type: String,
            default: '',
        },
        init_refer_idx: {
            type: [String, Number],
            default: null,
        },
        isNoticeInit: {
            type: Boolean,
            default: false
        },
        init_action_type: {
            type: Number,
            default: JOIN_CHAT_INIT_ACTION_TYPE.DEFAULT
        },
        customCloseAction: {
            type: Function,
            default: () => { }
        },
        user: {
            type: Object,
            default: () => { }
        },
        opponent_idx: {
            type: [Number, String],
            default: -1,
        },
        opponent_type: {
            type: [Number, String],
            default: -1
        },
        openMemberTalkInfo: {
            type: Object,
            default: () => { }
        },
        isRegistTeam: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isShowRejectedMessage: false,
            is_rejected_message: false,
            rejected_message_idx: null,
            TEAM_TYPE: TEAM_TYPE,
            JOIN_CHAT_INIT_ACTION_TYPE: JOIN_CHAT_INIT_ACTION_TYPE,
            JOIN_STATE: JOIN_STATE,
            menuOptions: {},
            JOIN_MEMBER_STATE: JOIN_MEMBER_STATE,
            DUES_TYPE: DUES_TYPE,
            MEMBER_TYPE: MEMBER_TYPE,
            JOIN_CHAT_HISTORY_TYPE: JOIN_CHAT_HISTORY_TYPE,
            JOIN_CHAT_TYPE: JOIN_CHAT_TYPE,
            socket: null,
            lastIdx: -1,
            isShowCalendar: false,
            msg: '',
            chatHistoies: [],
            isCoach: false,
            isConnecting: false,
            interval: null,
            members: [],
            isFirstConnecting: true,
            opponent_image_path: '',
            sockets: [],
            today: '',
            lastReadIdx: -1,
            REVIEW_PAGE_TYPE: REVIEW_PAGE_TYPE,
            title: '',
            subTitle: '',
            is_me_creator: false,
            contentsLength: 0,
            isShowJoinDetail: false,
            memberTalkScheduleIdx: -1,
            isOpenMemberTalkScheduleDetail: false,
            memberTalkDetailInitTab: -1,
            memberTalkDetailInitParam: '',
            isShowBottomPopMenu: false,
            joinDetail: {},
            scheduleIdx: -1,
            isOpenScheduleDetail: false,
            is_alarm_disable: -1,
            getPreviousChatFlag: true,
            prevChatHistories: [],
            single_opponent_member: {},
            isWithAdmin: false,
            chat_form_text: '',
            is_chat_form_input_show: false,
            chat_form_name: '',
            chat_form_phone: '',
            is_chat_form_complete: false,
            cert_upload_type: '',
            member_doc: {},
            navigation_bottom_height: 0,
            ori_navigation_bottom_height: 0,
            cur_modal_length: -1,
            v_is_disable_chat: false,
            isShowWelcomeMessage: false,
            window_height: 0,
            is_keyboard_up: false,
            review_not_confirmed_schedule: [],
            testCalendar: [],
            isShowContents: false,
            selectedTestDate: {
                date: '',
                time: ''
            },
            month: '',
            directMessageInfo: {},
            DIRECT_MESSAGE_TYPE: DIRECT_MESSAGE_TYPE,
            DIRECT_MESSAGE_STATUS: DIRECT_MESSAGE_STATUS,
            isShowSpeechBubble: true,
            isFocus: false,
            feedbacks : {}

        }
    },
    computed: {
        is_disable_chat() {
            return (this.chat.type != JOIN_CHAT_TYPE.GROUP && this.chat.type != JOIN_CHAT_TYPE.OPEN && this.v_is_disable_chat) || (this.is_rejected_message && this.$GlobalStore.loginInfo().is_temp_coach == 1);
        },
        is_chat_closed() {
            return this.chat.is_closed == '1'
        },
        chatHistoryCnt() {
            return this.chatHistoies.length;
        },
        myMemberIdx() {
            return parseInt(this.user.member_idx);
        },
        myMemberType() {
            return parseInt(this.user.member_type);
        },
        myNicName() {
            return this.user.nic_name;
        },
        myImagePath() {
            return this.user.image_path
        },
        requestStatus() {
            return parseInt(this.directMessageInfo.status)
        },
        isConfirmedTestDay() {
            if (this.directMessageInfo.test_date) {
                return true
            } else {
                return false
            }
        },
    },
    methods: {
        closeRejectedMessage() {
            this.isShowRejectedMessage = false
        },
        showTrainingVideoDetail(idx) {
            this.$GlobalStore.addModal('TrainingRequestDetail', { main_type: MAIN_TYPE.SOCCER_LEARN, isModalBackTransparent: true, isExpert: false, soccerhowIdx: idx, isPopular: false, isRealTime: false })
        },
        setFeedbackSoccerhow(soccerhow_idx){
            this.getFeedbackSoccerhow(soccerhow_idx);
        },
        async getFeedbackSoccerhow(soccerhow_idx){
            const parameters = {};
            parameters.idx = soccerhow_idx;

            this.feedbacks[soccerhow_idx] = {};

            const res = await this.$Axios.get('/api/soccerhow/list', {params : parameters});
            if(res.data.soccerHows.length > 0){
                const soccerhow = res.data.soccerHows[0];
                this.feedbacks[soccerhow_idx] = soccerhow;
                this.feedbacks[soccerhow_idx].imgSrcArr = []
                this.setImgSrcArr(soccerhow_idx)
            }
        },
        checkIfVideo(path, videoExtensions) {
            const extension = path.split('.').pop().toLowerCase();
            return videoExtensions.includes(extension);
        },
        setImgSrcArr(soccerhow_idx) {
            const imgSrcArr = []
            const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'qt']; // 동영상 확장자 목록
            for (let i = 1; i < 4; i++) {
                const key = `media_path${i}`;
                const thumbnail_key = `thumbnail_path${i}`
                if (this.feedbacks[soccerhow_idx][key]) {
                    const fullPath = this.$resourcePath + this.feedbacks[soccerhow_idx][key];
                    imgSrcArr.push({
                        path: fullPath,
                        videoPath: {
                            isVideo: this.checkIfVideo(fullPath, videoExtensions),
                            thumbnail_path: this.feedbacks[soccerhow_idx][thumbnail_key]
                        },
                        imageViewerPath: this.feedbacks[soccerhow_idx][key],
                    });
                }
            }
            this.feedbacks[soccerhow_idx].imgSrcArr = imgSrcArr
        },
        closePopup() {
            localStorage.setItem('IS_SHOW_SPEECH_BUBBLE', false)
            this.isShowSpeechBubble = false
        },
        async getIsExistDirectMessage() {
            this.isShowSpeechBubble = JSON.parse(localStorage.getItem('IS_SHOW_SPEECH_BUBBLE')) === null ? true : JSON.parse(localStorage.getItem('IS_SHOW_SPEECH_BUBBLE'))
            const parameters = {}
            parameters.opponent_idx = this.single_opponent_member.member_idx

            const res = await this.$Axios.get('/api/direct_message/mine/accepted', { params: parameters })
            const directMessageList = res.data.direct_message
            directMessageList.forEach(item => {
                if (item.type == DIRECT_MESSAGE_TYPE.CONTINUE_MESSAGE) {
                    if (item.is_skip == 1) {
                        this.is_rejected_message = true
                        this.rejected_message_idx = item.idx
                        this.isShowRejectedMessage = true
                    }
                }
            })
            this.setDirectMessage(directMessageList)
        },
        setDirectMessage(directMessageList) {
            if (directMessageList.length === 0) {
                return
            } else if (directMessageList.length === 1) {
                this.directMessageInfo = directMessageList[0]
            } else if (directMessageList.length >= 2) {
                this.directMessageInfo = directMessageList.find(item => item.type == DIRECT_MESSAGE_TYPE.REQUEST_TO_COACH || item.type == DIRECT_MESSAGE_TYPE.COACH_TO_REQUEST)
            }
            console.log(directMessageList)
            if(!this.directMessageInfo) this.directMessageInfo = {};

            if (this.directMessageInfo && this.directMessageInfo.test_date) {
                const date = this.directMessageInfo.test_date.split(' ')[0]
                this.setCalendarDay(date)
                this.selectedTestDate.date = date
            } else {
                this.setCalendarDay()
            }

            this.checkTestDate()
            this.goBottom()
        },
        checkTestDate() {
            if (this.directMessageInfo && this.directMessageInfo.test_date) {
                const test_date = this.directMessageInfo.test_date.split(' ')[0]

                if (test_date === this.today && this.directMessageInfo.status <= DIRECT_MESSAGE_STATUS.RESERVE_TEST_DATE) {
                    this.updateDirectMessageStatus()
                }
            }
        },
        async updateDirectMessageStatus() {
            const formData = new FormData()
            formData.append('status', DIRECT_MESSAGE_STATUS.PROGRESSING_TEST)
            formData.append('idx', this.directMessageInfo.idx)

            const res = await this.$Axios.post('/api/direct_message/update/status', formData)

            if (res.data.code === 0) {
                this.directMessageInfo.status = DIRECT_MESSAGE_STATUS.PROGRESSING_TEST
            }

        },
        transFontColor(isWeekend, date) {
            if (date === this.selectedTestDate.date) {
                return '#fff'
            } else if (isWeekend) {
                return '#FA1717'
            } else {
                return '#210f03'
            }
        },
        getTestDateStr() {
            const date = this.$Util.getMMDDDayHangulStrExceptionYYYY(this.selectedTestDate.date)
            const time = this.selectedTestDate.time.split(':')
            const hour = parseInt(time[0])

            if (hour < 12) {
                return date + ' ' + '오전 ' + time[0] + '시' + ' ' + time[1] + '분'
            } else {
                return date + ' ' + '오후 ' + time[0] + '시' + ' ' + time[1] + '분'
            }
        },
        getCompleteMsg(testDateStr) {
            let team_name;
            this.members.forEach(item => {
                if (item.member_idx === this.$GlobalStore.loginInfo().idx) {
                    team_name = item.team_name;
                }
            })
            return '테스트 일정이 확정 되었습니다@||' + testDateStr + '@||' + team_name
        },
        async setTime(time) {
            this.selectedTestDate.time = time
            this.$GlobalStore.showProgress()
            const testDate = this.selectedTestDate.date + ' ' + this.selectedTestDate.time
            const testDateStr = this.getTestDateStr()
            const completeMsg = this.getCompleteMsg(testDateStr)
            const formData = new FormData()
            formData.append('idx', this.directMessageInfo.idx)
            formData.append('status', DIRECT_MESSAGE_STATUS.RESERVE_TEST_DATE)
            formData.append('test_date', testDate)
            formData.append('complete_msg', completeMsg)
            formData.append('chat_idx', this.chatIdx)
            formData.append('opponent_idx', this.single_opponent_member.member_idx)
            formData.append('type', this.directMessageInfo.type)

            const res = await this.$Axios.post('/api/direct_message/reserve/test_date', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.hideProgress()
                this.closeCalendar()
                this.directMessageInfo.test_date = testDate
                this.directMessageInfo.status = DIRECT_MESSAGE_STATUS.RESERVE_TEST_DATE
                this.setCalendarDay(this.selectedTestDate.date)
                this.$GlobalStore.showToastVer2('테스트 일정이 저장되었습니다')
            } else {
                this.$GlobalStore.hideProgress()
                this.$GlobalStore.showAlert('다시 한 번 시도해주세요')
            }
        },
        setDate(date) {
            this.selectedTestDate.date = date
        },
        setCalendarDay(date) {
            if (date) {
                this.month = date.split('-')[1]
            } else {
                this.month = this.today.split('-')[1]
            }
            this.testCalendar = []
            const startOfWeek = moment(date).startOf('week')
            const daysKo = ['일', '월', '화', '수', '목', '금', '토'];
            for (let i = 0; i < 7; i++) {
                const current = startOfWeek.clone().add(i, 'day');
                this.testCalendar.push({
                    day: daysKo[i],
                    date: current.format('YYYY-MM-DD'),
                    isWeekend: daysKo[i] === '일' || daysKo[i] === '토' ? true : false,
                });
            }
        },
        setIsShowCalendar() {
            if (this.isConfirmedTestDay || this.$GlobalStore.loginInfo().is_temp_coach != 1) {
                return
            }
            this.isShowCalendar = true
            this.isShowContents = true
            this.selectedTestDate.date = this.today
        },
        closeCalendar() {
            this.isShowCalendar = false
            setTimeout(() => {
                this.isShowContents = false
            }, 500);
        },
        async saveReviewConfirmed() {
            if (this.review_not_confirmed_schedule.length === 0) return;

            const join_Schedule = window.copyObject(this.review_not_confirmed_schedule[0]);

            const parameters = {};
            parameters.join_schedule_idx = join_Schedule.join_schedule_idx;
            parameters.member_idx = join_Schedule.member_idx;
            const res = await this.$Axios.post('/api/join/schedule/review/confirm', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.review_not_confirmed_schedule = [];
                return join_Schedule;
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async showReviewForm() {
            const join_schedule_info = await this.saveReviewConfirmed();
            this.$GlobalStore.addModal('SendReview', { join_schedule_idx: join_schedule_info.join_schedule_idx })
        },
        async showReviews() {
            const join_schedule_info = await this.saveReviewConfirmed();
            this.$GlobalStore.addModal('ReviewHistory', { join_schedule_idx: join_schedule_info.join_schedule_idx, member_idx: join_schedule_info.member_idx, reviewPageType: REVIEW_PAGE_TYPE.RECEVIED })
        },
        detectTextAreaFocus() {
            this.isFocus = true
            if (this.$cookies.get('device') === 'android' || this.$cookies.get('device') === 'ios') {
                setTimeout(() => {
                    if ((this.$cookies.get('device') === 'android')) {
                        setTimeout(() => {
                            this.goBottom();
                        }, 100);
                    } else {
                        this.goBottom();
                    }
                    this.navigation_bottom_height = 0;
                }, 100)
            }
        },
        detectTextAreaBlur() {
            this.isFocus = false
            if (this.$cookies.get('device') === 'android' || this.$cookies.get('device') === 'ios') {
                this.navigation_bottom_height = this.$GlobalStore.navigationBarHeight();
            }
        },
        async showFileSelector(cert_upload_type) {
            this.cert_upload_type = cert_upload_type;
            this.$refs.file1.click();
        },
        async uploadCertFile() {
            const formData = new FormData();
            formData.append('file1', this.$refs['file1'].files[0]);
            formData.append('type', this.cert_upload_type);
            formData.append('chat_idx', this.chatIdx);
            const res = await this.$Axios.post('/api/player_cert/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            this.$refs['file1'].value = '';
            if (res.data.code === 0) {
                this.sendChat(JOIN_CHAT_HISTORY_TYPE.IMAGE, res.data.imagePath + "::" + res.data.ratio, true, null);
                this.getMemberDoc();
            } else {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async getMemberDoc() {
            const parameters = { chat_idx: this.chatIdx };
            const res = await this.$Axios.get('/api/player_cert/member_doc', { params: parameters });
            this.member_doc = res.data.member_doc;
        },
        sayHello() {
            this.msg = '안녕하세요! 👋';
            this.complete();
        },
        async saveChatForm() {
            if (this.chat_form_name.length === 0 && this.chat_form_phone.length === 0) {
                this.$GlobalStore.showAlert('이름 및 연락처를 입력해주세요.');
                return;
            }

            const parameters = {};
            parameters.name = this.chat_form_name;
            parameters.phone = this.chat_form_phone;

            const res = await this.$Axios.post('/api/chat/nologin/save/name', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.is_chat_form_complete = true;
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        setAlarmDisable(isOff) {
            this.is_alarm_disable = isOff;
        },
        showPersonalChatSetting() {
            this.$GlobalStore.addModal('PersonalChatSetting', { closeAction: this.customCloseAction, chat_idx: this.chatIdx, is_alarm_disable: this.is_alarm_disable, setAlarmDisable: this.setAlarmDisable, nic_name: this.title, single_opponent_member: this.single_opponent_member })
        },
        setCenter(lat, long) {
            this.$router.push({ path: '/view/mercenary' + '?time=' + new Date().getTime() });
            this.$GlobalStore.setIsFromJoinChat({ state: true, lat: lat, long: long })
            setTimeout(() => {
                this.$GlobalStore.closeModalAll()
            }, 500);
        },
        closeScheduleDetail() {
            this.isOpenScheduleDetail = false
        },
        async getMemberTalkDetail() {
            const parameters = {};
            parameters.join_idx = this.init_refer_idx;

            const res = await this.$Axios.get("/api/join/detail", { params: parameters });

            const join_detail = res.data.join_detail;
            this.joinDetail = join_detail;
            this.joinDetail.join_tag = this.joinDetail.join_tag.split(',')

            if (join_detail.join_way === JOIN_WAY.APPROVE && join_detail.password_hint === null && join_detail.creator_idx == this.myMemberIdx) {
                this.$GlobalStore.addModal('PrivateMemberTalk', { transitionName: 'bottom', memberTalkIdx: this.init_refer_idx })
            } else if ((join_detail.join_way === JOIN_WAY.APPROVE && join_detail.password_hint && join_detail.creator_idx == this.myMemberIdx) && (join_detail.join_tag === 'null' || join_detail.max_cnt === '0' || join_detail.age === '')) {
                this.$GlobalStore.addModal('MemberTalkDetailSetting', { memberTalkIdx: this.init_refer_idx })
            }

            if (join_detail.join_way === JOIN_WAY.ANYBODY && (join_detail.join_tag === 'null' || join_detail.max_cnt === '0' || join_detail.age === '')) {
                this.$GlobalStore.addModal('MemberTalkDetailSetting', { memberTalkIdx: this.init_refer_idx })
            }

            this.$nextTick(() => {
                if (this.joinDetail.image_path) {
                    const imageUrl = this.$resourcePath + this.joinDetail.image_path
                    // this.$refs.member_talk.style.backgroundImage = `linear-gradient(180deg, rgba(255, 255, 255, 0) 20%, rgba(255, 255, 255, 0.601454) 60%, rgba(255, 255, 255, 0.9) 80.4%, #FFFFFF 100%), url('${imageUrl}')`
                    this.$refs.member_talk.style.backgroundImage = `linear-gradient(180deg, rgba(33, 15, 3, 0) 0%, rgba(33, 15, 3, 0.7) 70%, #210F03 100%), url('${imageUrl}')`
                }
            })

            this.members.forEach(item => {
                if (item.member_idx === this.joinDetail.creator.member_idx) {
                    if (item.is_temp_coach == 1) {
                        this.isCoach = true
                    } else {
                        this.isCoach = false
                    }
                }
            })
        },
        showMemberTalkSetting() {
            this.$GlobalStore.addModal('MemberTalkSetting', { isCoach: this.isCoach, memberTalkIdx: this.init_refer_idx, completeAction: this.customCloseAction, chat: this.chat, status_bar_text_color: 'dark', memberTalkInfo: this.joinDetail, refreshAction: this.getMemberTalkDetail });
        },
        hideJoinDetail() {
            this.isShowJoinDetail = false;
        },
        calcContentsLength(e) {
            this.contentsLength = e.target.value.length
        },
        showFile() {
            if (this.is_rejected_message && this.$GlobalStore.loginInfo().is_temp_coach == 1) { 
                return
            }
            if (!this.is_disable_chat) this.$refs['file0'].click();
        },
        async uploadFile() {
            const formData = new FormData();
            formData.append('file0', this.$refs['file0'].files[0]);
            const res = await this.$Axios.post('/api/chat/upload/image', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
            this.$refs['file0'].value = '';
            if (res.data.code === 0) {
                this.sendChat(JOIN_CHAT_HISTORY_TYPE.IMAGE, res.data.imagePath + "::" + res.data.ratio, true, null);
            } else {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async checkReviewConfirmed() {
            const parameters = {};
            parameters.opponent_idx = this.single_opponent_member.member_idx;
            const res = await this.$Axios.get('/api/join/schedule/review/check', { params: parameters })
            if (res.data.join_schedules.length > 0) {
                this.review_not_confirmed_schedule = res.data.join_schedules;
            }
        },
        async getChatMembers() {
            const parameters = { chat_idx: this.chatIdx };

            const res = await this.$Axios.get('/api/chat/members', { params: parameters });

            this.members = res.data.members;
            if (this.chat && (this.chat.type == JOIN_CHAT_TYPE.SINGLE || this.chat.type == JOIN_CHAT_TYPE.CHAT_WITH_COACH || this.chat.type == JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT)) {
                for (const each of res.data.members) {
                    if (each.member_type != this.myMemberType || each.member_idx != this.myMemberIdx) {
                        this.title = each.nic_name;
                        this.opponent_image_path = each.image_path
                        this.single_opponent_member = each

                        if ((each.is_temp_coach == '1' || each.is_coach == '1') && each.state != JOIN_MEMBER_STATE.APPROVED) {
                            this.v_is_disable_chat = true;
                        }

                        if (this.chat.type == JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT) {
                            this.getMemberDoc();
                        }

                        if (this.chat.type == JOIN_CHAT_TYPE.CHAT_WITH_COACH) {
                            this.checkReviewConfirmed();
                        }

                        break;
                    }
                }

                //혼자일경우 채팅안되도록
                if(this.chat.type == JOIN_CHAT_TYPE.CHAT_WITH_COACH
                    && res.data.members.length > 0
                    && res.data.members.filter(each => each.state == JOIN_MEMBER_STATE.APPROVED).length < 2
                ){
                    this.v_is_disable_chat = true;
                }

            }

            this.members.forEach(item => {
                if (this.myMemberIdx == item.member_idx) {
                    this.is_alarm_disable = item.is_alarm_disable
                }
            })
            if (this.chat.type == JOIN_CHAT_TYPE.CHAT_WITH_COACH) this.getIsExistDirectMessage()

        },
        detectResize() {
            const device = this.$cookies.get('device')
            if (device === 'ios') {
                if (window.visualViewport.offsetTop === 0) {
                    this.is_keyboard_up = false;
                    this.$GlobalStore.unsetLastModalFixedInIOS(this.cur_modal_length - 1);
                } else {
                    this.is_keyboard_up = true;
                    this.$GlobalStore.setLastModalFixedInIOS(window.visualViewport.offsetTop, window.visualViewport.height);
                }
            } else if (device === 'android') {
                this.is_keyboard_up = this.window_height !== window.innerHeight;
            }
        },
        complete() {
            if (this.msg === '') return;
            this.$refs.contents.style.height = '40px';
            if (this.is_keyboard_up) {
                this.$refs.contents.focus()
                this.navigation_bottom_height = 0;
            }
            // this.socket.emit('CHAT', { nic_name : this.$GlobalStore.loginInfo().nic_name, contents : this.msg, image_path : this.$GlobalStore.loginInfo().image_path, type : JOIN_CHAT_HISTORY_TYPE.NORMAL});
            this.sendChat(JOIN_CHAT_HISTORY_TYPE.NORMAL, this.msg, true, null);
            this.msg = '';
            this.contentsLength = 0
        },
        async changeIsSecret() {
            const parameters = {};
            parameters.chat_idx = this.chatIdx;
            parameters.is_secret = 0;
            if (this.is_rejected_message) {
                parameters.rejected_message_idx = this.rejected_message_idx;
            }
            const res = await this.$Axios.post('/api/chat/change/is_secret', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                this.$set(this.chat, 'is_secret', 0);
                this.is_rejected_message = false;
                this.rejected_message_idx = null;
                this.isShowRejectedMessage = false;
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg);
            }
        },
        async sendChat(type, contents, isSendPush, refer_idx) {
            const isUser = this.$GlobalStore.loginInfo().is_temp_coach == 0
            const isSecretChat = this.chat.is_secret == 1
            const isSkipChat = this.is_rejected_message

            if (isUser && (isSecretChat || isSkipChat)) {
                await this.changeIsSecret();
            }
            if ((this.chat.type == JOIN_CHAT_TYPE.SINGLE
                // || this.chat.type == JOIN_CHAT_TYPE.CHAT_WITH_COACH //코치와의 대화는 참여가 바로 되지 않도록 변경.
                || this.chat.type == JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT)) {
                await this.refreshChatMember();
            }
            this.socket.emit('CHAT', { nic_name: this.myNicName, contents: contents, image_path: this.myImagePath, type: type, isSendPush: isSendPush, refer_idx: refer_idx });
        },
        async refreshChatMember() {
            const parameters = {};
            parameters.chat_idx = this.chat.idx;
            parameters.member_idx = this.single_opponent_member.member_idx;
            parameters.member_type = this.single_opponent_member.member_type;
            await this.$Axios.post('/api/chat/refresh/member', parameters);
        },
        enter() {
            // if(e.keyCode === 13){
            //     if(this.msg !== '' ) this.complete();
            // }
        },
        throttleScroll: () => { },
        detectReachTop(e) {
            const target = e.srcElement
            if (target.scrollTop >= 0 && target.scrollTop < 150) {
                if (this.getPreviousChatFlag) {
                    const saveScrollHeight = target.scrollHeight
                    this.getPreviousChatHistories(saveScrollHeight - (target.scrollTop - 110))
                }
            }
        },
        async getPreviousChatHistories(prevHeight) {
            this.getPreviousChatFlag = false
            if(this.chatHistoies.length === 0) return;

            const parameters = {}
            parameters.chat_idx = this.chatIdx
            parameters.first_idx = this.chatHistoies[0].idx
            const res = await this.$Axios.get('/api/chat/chats/prev', { params: parameters })
            if (prevHeight !== -1) {
                this.prevChatHistories = res.data.chatHistories
                if (this.prevChatHistories.length > 0) {
                    this.chatHistoies = [...this.prevChatHistories, ...this.chatHistoies]
                    this.$nextTick(() => {
                        const wrapper = this.$refs.scrollWrap
                        wrapper.scrollTo({
                            top: wrapper.scrollHeight - prevHeight,
                        })
                        this.getPreviousChatFlag = true
                    })
                }
                if (this.prevChatHistories.length < 30) {
                    this.isShowWelcomeMessage = true
                }
            } else {
                if (res.data.chatHistories.length === 0) {
                    this.isShowWelcomeMessage = true
                }
                this.getPreviousChatFlag = true
            }
        },
        goBottom() {
            this.$nextTick(() => {
                this.$refs.scrollWrap.scrollTop = this.$refs.scrollWrap.scrollHeight;
            });
        },
        showProfile(memberType, memberIdx) {
            this.$Util.showProfile('' + memberIdx, memberType);
        },
        getYoutubeUrl(contents) {
            const pattern = /https:\/\/youtu.be\/(\S+)\r?\n?|https:\/\/(?:www\.)?youtube.com\/shorts\/(\S+)\r?\n?|https:\/\/www.youtube.com\/watch\?v=(\S+)\r?\n?/is;
            const youtubeArr = pattern.exec(contents) ?? [];
            let youtube_url_type = '';
            let youtube_key = '';
            if (youtubeArr.length > 0) {
                if (youtubeArr[1]) {
                    youtube_url_type = 'be';
                    youtube_key = youtubeArr[1];
                } else if (youtubeArr[2]) {
                    youtube_url_type = 'shorts';
                    youtube_key = youtubeArr[2];
                } else if (youtubeArr[3]) {
                    youtube_url_type = 'watch';
                    youtube_key = youtubeArr[3];
                }
            }
            return [youtube_url_type, youtube_key];
        },
        connect() {
            const room = this.chatIdx;

            let url = '';
            if (process.env.NODE_ENV === 'development') {
                // 재택
                // url = 'http://192.168.0.203:8888/chat';
                // 사무실
                url = 'http://192.168.0.24:8888/chat';
                if (process.env.VUE_APP_CHATTING_SERVER !== undefined) {
                    url = process.env.VUE_APP_CHATTING_SERVER + '/chat';
                }
            } else {
                if (process.env.VUE_APP_IS_TEST_SERVER !== undefined) {
                    url = 'https://obyungear-user-test.ubiplus.co.kr:8889/chat';
                } else {
                    url = 'https://obyungear-user.ubiplus.co.kr:8888/chat';
                }
            }

            this.socket = io(url + '/' + room, {
                auth: { token: this.auth },
                transports: ['websocket'],
                // forceNew: true
            });

            this.sockets.push(this.socket);

            this.socket.on('connect', () => {
                console.log('연결됨');
                this.isFirstConnecting = false;
                this.isConnecting = false;
            });

            this.socket.on('LAST_IDX', () => {
                this.lastReadIdx = this.lastIdx;
                this.socket.emit('LAST_IDX', { last_idx: this.lastIdx });
            });

            this.socket.on('CHAT', (data) => {
                this.lastIdx = data.nextIdx;
                const chat_list = data.list;
                for (const each of chat_list) {

                    const [youtube_url_type, youtube_url_key] = this.getYoutubeUrl(each.contents);
                    if (youtube_url_type && youtube_url_key) {
                        each.youtube_url_type = youtube_url_type;
                        each.youtube_url_key = youtube_url_key;
                    }
                }
                this.chatHistoies = [...this.chatHistoies, ...chat_list];
                if (this.chatHistoies.length < 30) {
                    this.isShowWelcomeMessage = true
                }
                if (this.chatHistoies.length !== 0 && this.chat.type == JOIN_CHAT_TYPE.OPEN) {
                    this.getPreviousChatHistories(-1)
                }
                this.goBottom();

            });

            this.socket.on('COUNT_UPDATE', (data) => {
                const begin = data.begin;
                const end = data.end;

                for (let i = this.chatHistoies.length - 1; i >= 0; i--) {
                    const idx = this.chatHistoies[i].idx;
                    if (idx <= end && idx >= begin) {
                        this.$set(this.chatHistoies[i], 'read_count', this.chatHistoies[i].read_count - 1);
                    } else if (begin > idx) {
                        break;
                    }
                }
            });

            this.socket.on('DISABLE_CHAT', () => {
                this.v_is_disable_chat = true;
            });

            this.socket.on('EXIT', (data) => {
                this.$GlobalStore.showAlert(data.msg);
                this.$GlobalStore.closeLastModal();
            })
            const IS_SEND_REGIST_TEAM = JSON.parse(localStorage.getItem('IS_SEND_REGIST_TEAM'))
            if (this.isRegistTeam && !IS_SEND_REGIST_TEAM) {
                this.sendChat(JOIN_CHAT_HISTORY_TYPE.NORMAL, "팀 등록을 희망합니다.", true, null);
                localStorage.setItem('IS_SEND_REGIST_TEAM', true)
            }

        },
        setBackgroundImage() {
            const imageUrl = this.openMemberTalkInfo.imgPath
            // this.$refs.member_talk.style.backgroundImage = `linear-gradient(180deg, rgba(255, 255, 255, 0) 20%, rgba(255, 255, 255, 0.601454) 60%, rgba(255, 255, 255, 0.9) 80.4%, #FFFFFF 100%), url('${imageUrl}')`
            this.$refs.member_talk.style.backgroundImage = `linear-gradient(180deg, rgba(33, 15, 3, 0) 0%, rgba(33, 15, 3, 0.7) 70%, #210F03 100%), url('${imageUrl}')`
        },
        clearSockets() {
            for (let i = this.sockets.length - 1; i > -1; i--) {
                // if(this.sockets[i].connected){
                this.sockets[i].emit('FORCE_DISCONNECT');
                this.sockets.pop();
                // }
            }
        },
        clearSocketsExceptLast() {
            if (this.sockets.length > 1) {
                for (let i = 0; i < this.sockets.length - 1; i++) {
                    this.sockets[i].emit('FORCE_DISCONNECT');
                }

                this.sockets = [this.socket];
            }
        },
        showImageViewer(e) {
            const imagePath = e.currentTarget.getAttribute('image_path');
            this.$GlobalStore.addModal('ImageViewer', { imagePaths: [imagePath] });
        },
        async getChatFormWithAdmin() {
            const res = await this.$Axios.get('/api/chat/form_introduce');
            this.chat_form_text = res.data.chat_form_text;
            this.is_chat_form_input_show = res.data.is_chat_form_input_show;

            if (res.data.is_chat_form_input_show) {
                setTimeout(() => {
                    if (this.$refs.chat_form_input_phone && this.$refs.chat_form_input_phone.length > 0) {
                        this.$Util.setPhoneFormatter(this.$refs.chat_form_input_phone[0])
                    }
                }, 500);
            }

            this.goBottom();
        }

    },
    beforeDestroy() {
        // this.socket.emit('FORCE_DISCONNECT');
        this.clearSockets();

        // this.socket = null;
        clearInterval(this.interval);
        window.visualViewport.removeEventListener('resize', this.detectResize);
    },
    mounted() {
        window.visualViewport.addEventListener("resize", this.detectResize);
    },
    created() {
        this.saveChatForm = this.$Once(this.saveChatForm);
        this.approveJoin = this.$Once(this.approveJoin);
        this.saveReviewConfirmed = this.$Once(this.saveReviewConfirmed);

        this.window_height = window.innerHeight;

        this.cur_modal_length = this.$GlobalStore.getModalLength();

        const device = this.$cookies.get('device')

        if (device === 'android' || device === 'ios') {
            this.navigation_bottom_height = this.$GlobalStore.navigationBarHeight();
            this.ori_navigation_bottom_height = this.$GlobalStore.navigationBarHeight();
        }

        this.today = moment().format('YYYY-MM-DD');

        this.getChatMembers();

        if (this.chat.type == JOIN_CHAT_TYPE.SINGLE) {
            this.subTitle = '1:1채팅';

            //문의 일때
            const admin_member_idx = this.$Util.getAdminMemberIdx();
            if (this.opponent_idx == admin_member_idx && this.opponent_type == MEMBER_TYPE.USER) {
                this.isWithAdmin = true;
                this.getChatFormWithAdmin();

                this.chat_form_name = this.user.name ?? '';
                this.chat_form_phone = this.user.phone ?? '';

                if (this.user.member_type == MEMBER_TYPE.NOLOGIN) {
                    if (this.user.name) this.is_chat_form_complete = true;
                }
            }
        } else if (this.chat.type == JOIN_CHAT_TYPE.CHAT_FOR_COACH_CERT) {
            this.title = '이름';
        } else {
            this.subTitle = '그룹채팅';
        }

        if (this.pTitle && this.chat.type == JOIN_CHAT_TYPE.GROUP) this.title = this.pTitle;

        this.isConnecting = true;

        this.connect();
        this.interval = setInterval(() => {
            if (this.isFirstConnecting) return;
            this.clearSocketsExceptLast();
            if (window.isScreenActive) {
                if (!this.socket.connected && !this.isConnecting && this.sockets.length === 0) {
                    this.isConnecting = true;
                    this.connect();
                }
            } else {
                this.clearSockets();
            }

        }, 1000);

        if (this.chat.type == JOIN_CHAT_TYPE.GROUP) this.getMemberTalkDetail()

        this.throttleScroll = _.debounce((e) => {
            this.detectReachTop(e);
        }, 200);
        this.$nextTick(() => {
            if (this.chat.type == JOIN_CHAT_TYPE.OPEN) {
                this.setBackgroundImage()
            }
        })
    },

}
</script>

<style scoped>
.circle_wrap {
    border-radius: 2px;
}

.circle_text {
    position: absolute;
    white-space: nowrap;
    font-size: 12px;
    line-height: 20px;
    font-weight: 500;
    left: 50%;
    transform: translateX(-50%);
    top: 22px;
    color: #808080;
}

.circle_text_active {
    top: 18px;
    color: #210f03;
}

.inner_circle {
    width: 20px;
    height: 20px;
    position: relative;
    border-radius: 50%;
    margin-left: auto;
    transform: translateY(-8px);
    background-color: #bbbbbb;
}

.inner_circle_active {
    border: 4px solid #DF5A00;
    background-color: var(--color-main);
}

.circle_wrap_active {
    background-color: var(--color-main);
}

* {
    font-family: var(--global-font-family)
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

.ballon_wrap {
    padding-left: 20px;
}

.ballon {
    max-width: 60%;
    padding: 8px 12px;
    margin-top: 10px;
    border-radius: 15px;
    display: inline-block;
    font-size: 15px;
}


.line {
    height: 1px;
    background-color: #bbbbbb;
}

.member+.member {
    margin-top: 10px
}

.round {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: white;
    width: 35px;
    height: 35px;
    font-size: 13px;
    white-space: nowrap;
}

.round+.round {
    margin-left: 10px;
}

.bottom-enter-active,
.bottom-leave-active {
    transition: top .5s;
}

.bottom-enter,
.bottom-leave-to {
    top: 100%;
}

.member_talk_chat_wrap {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.member_talk_chat_ball {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: var(--color-main);
}

.member_talk_chat_sentence {
    color: #606060;
    background-color: #F5F5F5;
    font-size: 12px;
    font-weight: bold;
    border-radius: 12px;
    padding: 10px 10px;
    margin: 0px 10px;
}


.chat_form_input {
    height: 50px;
    border-radius: 25px;
    border: 2px solid #D9D9D9;
    width: 100%;
    font-size: 14px;
    font-weight: 500;
    padding: 0px 20px;
    color: #210F03;
    outline: none;
}

.chat_form_input::placeholder {
    color: #BBBBBB;
}

.chat_form_input_confirm_btn {
    height: 50px;
    border-radius: 25px;
    border: 2px solid #D9D9D9;
    font-weight: 500;
    font-size: 14px;
    color: white;
    background-color: #D9D9D9;
    display: grid;
    place-items: center;
}

.chat_form_input_confirm_btn.active {
    background-color: #210F03;
}

.header {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
}
</style>